// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDAMi3cKrrx-CglAbpxMbmDGA7o3L5D0lQ",
  authDomain: "kolokolo-chat.firebaseapp.com",
  projectId: "kolokolo-chat",
  storageBucket: "kolokolo-chat.appspot.com",   // ← fixed
  messagingSenderId: "191249455693",
  appId: "1:191249455693:web:d39d67551b5d2849135a04",
  measurementId: "G-D19Z62397G"
};

const app       = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth      = getAuth(app);
const db        = getFirestore(app);  

export { app, analytics, auth, db };
